import type { Competition } from "../../lib/queries/competitions";
import type { ID } from "../../lib/id";

interface Crumb {
  label: string;
  href?: string;
}

/**
 * The breadcrumb prefix every `/soutez/:id/*` page shares:
 *
 *   Soutěže / Kvalifikační kolo MČR ČMF – Hluk / Soutěžní kategorie
 *
 * Seven pages wrote that literal out, which is how the middle crumb came
 * to be dead on all of them: it named the competition and linked
 * nowhere, so the one way back to Přehled from a sub-page was the
 * sidebar. It links there now, and it does so in one place, so the
 * eighth page cannot forget.
 *
 * The competition may still be loading, hence the optional argument and
 * the „Soutěž" placeholder: a trail that appears one render later jumps
 * the whole page.
 *
 * Safe on Přehled itself. The library renders the LAST crumb as the
 * current page and ignores its `href`, so calling this with no tail
 * gives the same dead crumb it always had rather than a link to the page
 * you are on.
 *
 * `StartListViewPage` is exempt and must stay so: it is deliberately
 * chromeless for printing and renders no `Topbar` at all.
 */
export function competitionCrumbs(
  competitionId: ID,
  competition: Competition | undefined,
  ...tail: Crumb[]
): Crumb[] {
  return [
    { label: "Soutěže", href: "/admin/souteze" },
    { label: competition?.name ?? "Soutěž", href: `/soutez/${competitionId}` },
    ...tail,
  ];
}
